import * as React from 'react';
import { reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { connect } from 'react-redux';
import { getAddress, getState } from '../../../../ducks/onboard/onboardSelectors';
import { AscendState } from '../../../../ducks';

const AgreementPage2 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="advisorAndClient" currentPage={2}>
    This Client Services Agreement is made between Ascend Debt Relief PLLC (“Ascend”), a Delaware limited
    liability company, and <i>{props.name}</i>, currently residing at <i>{props.address}</i>. Client
    is a resident of <i>{props.clientState}</i>. This agreement will become effective once Ascend
    receives the signed copy of each of the required documents (“Effective Date”).
    <br />
    <br />
    A) <b>Ascend Guarantee</b>: Ascend will not charges any fee for its services until a debt has
    been successfully settled and a payment has been made toward that debt. When one of your debts
    is settled, we will charge the fee associated with your program at that time. The fees are
    described in more details below.
    <br />
    <br />
    B) <b>Ascend Responsibilities</b>: Ascend will work in good faith to resolve each of the debts
    enrolled into the Ascend program. We believe that each Creditor will work with Ascend. We will
    keep you informed of our negotiation efforts on your behalf and advise if anything significant
    has changed that would affect estimated amounts of the settlements.
    <br />
    <br />
    C) <b>Program Length</b>: While we estimated a program length that we believe is appropriate
    to resolve your debts, the actual length of the program may vary depending on your ongoing
    ability to save and make payments on your debts, your creditors’ willingness to settle the
    debts, and the structure by which your creditors settle those debts.
    <br />
    <br />
    D) <b>Your responsibilities</b>: You will respond truthfully and cooperatively to all inquiries
    and requests Ascend has for you. You will also verify your creditor’s information, and notify us
    of any changes that occur. You shall notify Ascend if you receive or have any proposed
    settlement offers directly from your creditors.
    <br />
    <br />
    <b>Program savings</b>: After this agreement is effective, you will save a certain amount agreed
    upon by Ascend and you each month. These funds will be under your control at all times and will
    be utilized once a settlement has been made.
    <br />
    <br />
    <b>Certification of Financial Hardship</b>: By agreeing and signing this document, you agree
    that you are in financial hardship and are unable to pay or continue to make the monthly minimum
    payments to Creditors without more devastating financial hardship. You confirm that all
    financial information provided to Ascend is correct and accurate. You also confirm that you have
    considered other ways to resolve your debt such as bankruptcy and debt consolidation.
    <br />
    <br />
    <b>Limitations and Exclusions of the Program</b>: You understand and confirm that Ascend does
    not provide legal, bankruptcy, accounting, tax or investment advice. We will also make no claim
    that Ascend’s debt settlement program will improve your credit rating or that your creditors
    will stop collection phone calls or communications to you although we will make our best
    reasonable effort to assist in both of these areas. You understand there may be adverse
    reporting from your creditors and/or lawsuit(s) being filed against you by your creditor(s). We
    take
    our best efforts using previous lawsuit data to prevent this, but it may happen.
    <br />
    <br />
    <b>Credit Reporting Review Authorization</b>: By your execution of this agreement, you give
    Ascend authorization to obtain one or more credit reports about your current situation from any
    of the credit reporting agencies included but not limited to Transunion, Experian or Equifax.
    This is done for the purpose of performing debt settlement services and this authorization is
    valid until the program is complete or if you state in writing that this authorization is no
    longer in effect.
    <br />
    <br />
    E) <b>Program Withdrawal</b>: You may terminate this agreement at any point in time and withdraw
    from the program without incurring any termination fee or penalty. However, you will be
    responsible to pay for any fees incurred for services performed by Ascend, up to the effective
    date of the termination. You may terminate this Agreement by completing the “Notice of
    Cancellation” as seen below. It may take up to five (5) business days for this change to take
    effect.
    <br />
    <ol style={{ listStyleType: 'lower-roman' }}>
      <li>
        <b>Ascend's Right to Terminate:</b> "Ascend reserves the right to remove the client from the
        program at any time and terminate this agreement for any reason, including but not limited
        to failure to cooperate, provide necessary information, or comply with the terms outlined in
        this agreement. Ascend will notify the client in writing prior to such termination, and the
        client will only be responsible for fees incurred for services performed up to the date of
        termination."
      </li>
    </ol>
    <br />
    F) <b>The Ascend Power of Attorney role</b>: Ascend shall work on your behalf as an independent
    contractor. Ascend does not have any authority to bind or contract you other than what is
    expressly authorized in the Limited Power of Attorney.
    <br />
    <br />
    G) <b>No Attorney-Client Relationship: Ascend is NOT a law firm, nor does it provide legal advice or legal assistance to its Clients. Ascend does offer any legal services to its Clients. This Agreement and any debt settlement services provided by Ascend should not be interpreted as providing any legal services, legal advice or legal opinion. No attorney-client relationship is formed by this Agreement or any other agreements, documents, or other items between the Parties. If legal assistance is required, the Client should consult an attorney. </b>
    <br />
    <br />
    H) <b>Agreement Amendment and Modification</b>: This agreement is the exclusive statement of
    Ascend and your mutual understanding and relationship. This agreement may only be modified or
    amended by Ascend and you provided that the change be in writing by both parties.
    <br />
    <br />I read and understand to be bound by the terms of the Ascend Client Services Agreement, as
    set forth above and in the following exhibits, schedules and attachments. I further acknowledge
    that I understand the terms and conditions of this agreement and those terms have been explained
    to my satisfaction. I further acknowledge that this agreement and the program disclosures have
    been presented in my primary language and that I have no unanswered questions about the program
    or this agreement at this time. You may cancel this Agreement at any time, which is further
    described by the Notice of Cancellation Rights below.
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage2 as any);

export default connect((state: AscendState) => ({
  name: formSelector(state, 'name'),
  existingSignature: formSelector(state, 'clientSignature'),
  clientState: getState(state),
  address: getAddress(state),
}))(form) as any;
